import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { Result } from "../../../api/result.ts";
import { createElement } from "react";
import { Trans } from "react-i18next";
import { put } from "../../../api/apiShared.ts";
import { SetSavedViewAsGlobalDialogProps } from "./SetSavedViewAsGlobalDialog.tsx";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function useSetSavedViewAsGlobalDialog(props: SetSavedViewAsGlobalDialogProps) {
    const snackbar = useDotLegalSnackbar();

    const setViewAsGlobalMutation = useDotLegalMutation(setViewAsGlobalApi);

    const handleViewAsGlobal = () => {
        setViewAsGlobalMutation.mutateAsync(props.view.id, {
            onSuccess: (response: Result<string>) => {
                snackbar.show(
                    createElement(Trans, {
                        i18nKey: "viewSetAsGlobalSuccess",
                        values: { name: props.view.name },
                    })
                );
                props.onClose();
                props.onSuccess();
            },
        });
    };

    return {
        handleViewAsGlobal,
        inProgress: setViewAsGlobalMutation.isLoading,
    };

    async function setViewAsGlobalApi(viewId: string) {
        return await put<string>(`/saved-views/${viewId}/set-as-global`, {});
    }
}
